
        window.getEnvironmentFromURL = () => 'dev'
        window.__URI__ = () => 'wss://dev.signaling.aire.link/s1/jsonrpc'
      